import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function Cancel() {
  return (
    <div
      data-testid="cancel-page"
      className="min-h-screen bg-[#050505] flex items-center justify-center px-6"
    >
      <div className="max-w-lg w-full bg-[#0f0f0f] border border-white/10 p-10 text-center">
        <XCircle className="mx-auto text-white/70" size={56} />
        <h1 className="mt-6 font-heading text-5xl uppercase">Checkout Cancelled</h1>
        <p className="mt-3 text-white/70">
          No charge was made. You can try again whenever you're ready.
        </p>
        <Link
          to="/"
          data-testid="cancel-home-link"
          className="mt-8 inline-flex px-8 py-3 bg-[#d4af37] text-black text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#f1c40f]"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
